import { Message } from '@ok/okd';

const { ont } = window.utils;

// eslint-disable-next-line max-params
async function ajax(
  method,
  url,
  params,
  showErrorMsg,
  customConfig = undefined
) {
  return ont[method](url, params || undefined, customConfig)
    .then(({ data }) => {
      if (data.code == 0) {
        return data.data;
      }

      // Unified processing of error messages
      if (showErrorMsg && data?.msg) {
        Message.error(data.msg);
      }

      throw data;
    })
    .catch((err) => {
      let handleErr = err;
      if (err.status === 401) {
        handleErr = null;
      }
      throw handleErr;
    });
}

export async function get(url, params = {}, showErrorMsg = true) {
  const method = 'get';
  return ajax(method, url, { params }, showErrorMsg);
}

export async function post(url, params = {}, showErrorMsg = true) {
  const method = 'post';
  return ajax(method, url, params, showErrorMsg);
}

export default ont;
